import mapValues from 'lodash/mapValues';
import isObject from 'lodash/isObject';
export default function daContentNormalizer(content) {
    if (!content.entityMap) {
        content.entityMap = {};
    }
    mapValues(content.entityMap, (entity)=>{
        if (entity && entity.type === 'wix-draft-plugin-giphy') {
            var _entity_data, _entity_data_gif;
            const fixed = {
                config: {
                    size: 'small',
                    alignment: 'center'
                },
                gif: {
                    originalUrl: ''
                }
            };
            if (typeof (entity === null || entity === void 0 ? void 0 : (_entity_data = entity.data) === null || _entity_data === void 0 ? void 0 : (_entity_data_gif = _entity_data.gif) === null || _entity_data_gif === void 0 ? void 0 : _entity_data_gif.originalUrl) !== 'string') {
                entity.data = fixed;
            }
        }
    });
    mapValues(content.blocks, (block)=>{
        if (!Array.isArray(block === null || block === void 0 ? void 0 : block.entityRanges)) {
            block.entityRanges = [];
        } else {
            mapValues(block.entityRanges, (entityRange)=>{
                if (!isObject(entityRange)) {
                    entityRange = {
                        offset: 0,
                        key: 0,
                        length: 0
                    };
                }
                if (!(entityRange === null || entityRange === void 0 ? void 0 : entityRange.offset)) {
                    entityRange.offset = 0;
                }
                if (!(entityRange === null || entityRange === void 0 ? void 0 : entityRange.key)) {
                    entityRange.key = 0;
                }
                if (!(entityRange === null || entityRange === void 0 ? void 0 : entityRange.length)) {
                    entityRange.length = 0;
                }
            });
        }
        if (!Array.isArray(block === null || block === void 0 ? void 0 : block.inlineStyleRanges)) {
            block.inlineStyleRanges = [];
        } else {
            mapValues(block.inlineStyleRanges, (inlineRange)=>{
                if (!isObject(inlineRange)) {
                    inlineRange = {
                        offset: 0,
                        style: 'BOLD',
                        length: 0
                    };
                }
                if (!(inlineRange === null || inlineRange === void 0 ? void 0 : inlineRange.length)) {
                    inlineRange.length = 0;
                }
                if (!(inlineRange === null || inlineRange === void 0 ? void 0 : inlineRange.offset)) {
                    inlineRange.offset = 0;
                }
                if (!(inlineRange === null || inlineRange === void 0 ? void 0 : inlineRange.style)) {
                    inlineRange.style = 'BOLD';
                }
                if (inlineRange === null || inlineRange === void 0 ? void 0 : inlineRange.style.startsWith('TEXT_TOOLS_COLOR_')) {
                    const parts = inlineRange.style.split('_');
                    if (parts[3]) {
                        inlineRange.style = JSON.stringify({
                            FG: parts[3]
                        });
                    }
                }
            });
        }
        if (!(block === null || block === void 0 ? void 0 : block.depth)) {
            block.depth = 0;
        }
        if (!(block === null || block === void 0 ? void 0 : block.key)) {
            block.key = 'foo';
        }
        if (!(block === null || block === void 0 ? void 0 : block.text)) {
            block.text = '';
        }
        if (!(block === null || block === void 0 ? void 0 : block.type)) {
            block.type = 'unstyled';
        }
    });
    return content;
}
